// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","455":"023cb25f","977":"1ff7fdd1"}[chunkId] + ".chunk.js";
};